import React, { Component } from "react";
import { numberWithCommas } from "../../../../helpers/dataHelpers";
import moment from "moment";
import ReactDOM from "react-dom";
import { Chart } from "react-chartjs-2";

const appendActiveList = (list, viewBy) => {
  return list.map((d) => {
    return {
      name: moment(new Date(d.year, d.month - 1)).format("MMM YYYY"), // Format as MM YYYY
      value: viewBy === "piece" ? d.totalPieces : d.totalPrincipal,
    };
  });
};

const appendTargetList = (list, viewBy) => {
  return list.map((d) => {
    return { value: viewBy === "piece" ? d.targetPieces : d.targetPrincipal };
  });
};

class GraphView extends Component {
  state = { isLoading: false };

  chart = null;

  componentDidMount() {
    this.InventoryChart({
      title: localStorage.getItem("inventoryTarget"),
      parent_chart: this.chart,
      target_list: this.props.target_list,
      viewBy: this.props.toView,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.target_list != null && prevProps.target_list.length !== 0) {
      const new_target_list = this.props.target_list;
      const toView = this.props.toView;
      if (
        prevProps.target_list !== new_target_list ||
        prevProps.toView !== toView
      ) {
        if (window.chart !== null && window.chart !== undefined) {
          this.clearChartData();
        }

        this.setState({ new_target_list: new_target_list });
        this.InventoryChart({
          title: localStorage.getItem("inventoryTarget"),
          parent_chart: this.chart,
          target_list: new_target_list,
          viewBy: toView,
        });
      }
    }
  }

  clearChartData = () => {
    window.chart.destroy();
  };

  renderChart = () => {
    return (
      <div id="chartParent">
        <canvas
          id="mixedChart"
          style={{ maxHeight: 500 }}
          ref={(chart) => {
            this.chart = chart;
          }}
          height={100}
        />
      </div>
    );
  };

  render() {
    return <div>{this.renderChart()}</div>;
  }

  InventoryChart = (props) => {
    try {
      const chartCanvas = ReactDOM.findDOMNode(this.chart);
      var ctx = document.getElementById("mixedChart").getContext("2d");
      var barGradientStroke = ctx.createLinearGradient(1200, 0, 0, 0);
      barGradientStroke.addColorStop(0, "#32ff7e");
      barGradientStroke.addColorStop(1, "#1e90ff");
      var activeInventoryData = appendActiveList(
        props.target_list,
        props.viewBy
      );
      var targetInventoryData = appendTargetList(
        props.target_list,
        props.viewBy
      );
      var activeInventory = {
        items: activeInventoryData.map((item) => item.value),
        labels: activeInventoryData.map(
          (item) => `${item.name} (${item.value})`
        ),
        colors: activeInventoryData.map(() => barGradientStroke),
      };
      const lineGradientStroke = ctx.createLinearGradient(0, 0, 0, 510);
      lineGradientStroke.addColorStop(0, "#32ff7e");
      lineGradientStroke.addColorStop(1, "#0984e3");

      var targetInventory = {
        items: targetInventoryData.map((item) => item.value),
        colors: activeInventoryData.map((item) => lineGradientStroke),
      };

      var chart_options = this.inventory_target_chart_data(
        targetInventory,
        activeInventory,
        this.props.title
      );

      this.renderChartActualObject({
        chartCanvas: chartCanvas,
        chart_options: chart_options,
      });
    } catch { }
  };

  renderChartActualObject = (props) => {
    var chartItem = new Chart(props.chartCanvas, props.chart_options);
    window.chart = chartItem;
    return chartItem;
  };

  inventory_target_chart_data = (
    inventoryTargetData,
    activeInventoryData,
    title
  ) => {
    return {
      type: "bar",
      options: {
        title: {
          display: true,
          text: title,
          fonsize: 20,
        },

        responsive: true,
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 20,
            bottom: 0,
          },
        },
        clamp: true,
        tooltips: {
          mode: "label",
          callbacks: {
            label: function (tooltipItem, data) {
              return (
                data.datasets[tooltipItem.datasetIndex].label +
                ": " +
                numberWithCommas(tooltipItem.yLabel)
              );
            },
          },
        },
        scales: {
          xAxes: [
            {
              stacked: false,
              gridLines: {
                display: true,
              },
              ticks: {
                callback: function (value) {
                  return moment(value).format("MMM YYYY");
                },
              },
            },
          ],
          yAxes: [
            {
              stacked: true,
              ticks: {
                callback: function (value) {
                  return numberWithCommas(value);
                },
              },
            },
          ],
        }, // scales
        legend: {
          display: true,
        },
      },
      data: {
        datasets: [
          {
            datalabels: {
              clamp: true,
              color: "#212121",
              align: "top",
              backgroundColor: "#f1f2f6",
              borderRadius: 3,
              borderWidth: 1,
              borderColor: "#a4b0be",
              formatter: function (value, context) {
                return numberWithCommas(value);
              },
              font: function (context) {
                var width = context.chart.width;
                var size = Math.round(width / 90);
                return {
                  size: size,
                };
              },
            },
            pointStyle: "circle",
            pointBackgroundColor: "#2ed573",
            data: inventoryTargetData.items,
            type: "line",
            borderColor: "#2f3542",
            borderWidth: 1,
            label: "Target Inventory",
            fill: inventoryTargetData.colors,
          },
          {
            datalabels: {
              color: "#212121",
              align: "center",
              formatter: function (value, context) {
                return numberWithCommas(value);
              },
              font: function (context) {
                var width = context.chart.width;
                var size = Math.round(width / 90);
                return {
                  size: size,
                };
              },
            },
            label: "Active Inventory",
            data: activeInventoryData.items,
            type: "bar",
            hoverBorderWidth: 1,
            hoverBorderColor: "#6c5ce7",
            backgroundColor: activeInventoryData.colors,
          },
        ],
        labels: activeInventoryData.labels,
      },
    };
  };
}

export default GraphView;
